import React from 'react';
import {MenuItem} from '@mui/material';
import CustomFormControl from '../../Dropdown/CustomFormControl';

const AlertTargetSelector = ({ value, onChange, error }) => {
    const targets = [
        { label: 'All Markets', value: 'ALL_MARKETS' },
        { label: 'Targeted Market', value: 'TARGETED_MARKETS' },
      
    ];

    return (
        <div className="alert-level-container">
            <label>ALERT TARGET</label>
            <CustomFormControl
                value={value}
                onChange={onChange}
                displayEmpty
                required
                error={error}
                helperText={error ? "This field is required" : ""}
                renderValue={(selected) =>
                    selected
                        ? targets.find(l => l.value === selected)?.label
                        : <span style={{ fontSize: "12px", color: "#bab7b7" }}>Alert Target</span>
                }
            >
                <MenuItem disabled value="">
                    <span style={{ fontSize: "12px", color: "black" }}>Alert Target</span>
                </MenuItem>
                {targets.map(l => (
                    <MenuItem key={l.value} value={l.value} sx={{ fontSize: "12px", color: "black" }}>
                        {l.label}
                    </MenuItem>
                ))}
            </CustomFormControl>
        </div>
    );
};

export default AlertTargetSelector;
